import { Deserializable } from '../protocols/deserializable';

// minimum, maximum and ceiling are per payment
export class VariableBenefitTargetPaymentAccount implements Deserializable {
  public governingJurisdictionId!: number | null;
  public minimum!: number;
  public maximum!: number | null;
  public ceiling!: number;
  public uncapped!: boolean;
  public topUp!: number;
  public recurringPaymentAmount!: number;

  public onDeserialize(): void {}
}
